<template>
  <div id="amt-chart">
    <div class="amt-chart-value">
      <!-- <div class="amt-container">
        <span class="amt-text">9</span>
      </div>
      <div class="amt-container">
        <span class="amt-text">9</span>
      </div>
      <div class="amt-container">
        <span class="amt-text">9</span>
      </div>
      <div class="amt-container-comma">
        <span class="amt-text">,</span>
      </div>
      <div class="amt-container">
        <span class="amt-text">9</span>
      </div>
      <div class="amt-container">
        <span class="amt-text">9</span>
      </div>
      <div class="amt-container">
        <span class="amt-text">9</span>
      </div> -->

      <div class="amt-container" v-for="(item, index) in intArr" :key="index">
        <span class="amt-text">{{ item }}</span>
      </div>


      <div class="decimal-container">
        <div class="decimal-container-dot">
          <span class="amt-decimal-text">.</span>
        </div>
        <!-- <div class="decimal-container-num">
          <span class="amt-decimal-text">9</span>
        </div>
        <div class="decimal-container-num">
          <span class="amt-decimal-text">9</span>
        </div> -->

        <div class="decimal-container-num" v-for="(item, index) in decimalArr" :key="index">
          <span class="amt-decimal-text">{{ item }}</span>
        </div>
      </div>

    </div>

    <!-- <div class="amt-chart-details">
      <div class="amt-chart-details-left">
        <div class="left-icon"></div>
        <div></div>
      </div>
      <div class="amt-chart-details-right"></div>
    </div>

    <div class="amt-chart-other">
    </div> -->



  </div>
</template>

<script>
export default {
  name: 'AmtChart',
  props: {
    amt: {
      type: String,
      default: '0.00'
    }
  },
  data() {
    return {
      intArr: [],
      decimalArr: [],
      config: {
        data: [45],
        shape: 'round',
        waveHeight: 25,
        waveNum: 2
      }
    }
  },
  mounted() {
    this.init(this.amt);
  },
  watch: {
    amt: {
      handler: function (val) {

        this.init(val);
      },
      deep: true
    }
  },
  methods: {
    init(amt) {
      this.intArr=[];
      let intS = amt.split('.')[0];
      let decimalS = amt.split('.')[1] || '00';
      let arr = intS.split('');
      let index = 0;
      // 千分位插入,
      for (let i = arr.length - 1; i >= 0; i--) {
        if (index % 3 == 0 && index != 0) {
          this.intArr.push(',');
        }
        this.intArr.push(arr[i]);
        index++;
      }
      // 反转数组
      this.intArr = this.intArr.reverse();


      this.decimalArr = decimalS.split('');
    }
  }

}
</script>

<style lang="less" scoped>
#amt-chart {
  height: 100%;
  width: 100%;

  .amt-chart-value {
    height: 100%;
    width: 100%;
    margin-bottom: 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }



  .amt-chart-details {
    height: 36%;
    width: 100%;

    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    /* 新增 */

  }

  .amt-chart-details-left {
    flex: 1;
    width: 48%;
    height: 100%;
    background: rgba(24, 50, 148, 0.30);
    border: 1px solid;
    border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
    border-radius: 8px;
    margin-right: 10px;

    align-items: center;
    display: flex;
  }

  .amt-chart-details-right {
    flex: 1;
    width: 48%;
    height: 100%;
    background: rgba(24, 50, 148, 0.30);
    border: 1px solid;
    border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
    border-radius: 8px;
    margin-left: 10px;
  }

  .amt-chart-other {
    height: 18%;
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.30);
    border-radius: 8px;
    margin-bottom: 20px;

  }

  .amt-container {
    width: 4vw;
    height: 11vh;
    background: #0226b5;
    border-radius: 8px;
    margin-right: 5px;
  }

  .decimal-container {
    width: 5.7vw;
    height: 11vh;
    display: flex;
    align-items: self-end;

  }

  .amt-container-comma {
    width: 1.66666vw;
    height: 11vh;
    // background: #0226b5;
    border-radius: 8px;
    margin-right: 5px;
  }

  .decimal-container-dot {
    width: 1.66666vw;
    height: 5.789475vh;
  }

  .decimal-container-num {
    width: 2.08333vw;
    height: 5.789475vh;
    background: #0226b5;
    border-radius: 8px;
    margin-right: 5px;
  }


  .amt-text {
    width: 2.1vw;
    height: 10vh;
    font-size: 3.5vw;
    font-weight: bold;
    text-align: center;
    color: #ffa837;
    line-height: 11vh;
  }

  .amt-decimal-text {

    font-size: 1.82291vw;
    font-weight: bold;
    text-align: center;
    color: #ffa837;
    line-height: 5.78947vh;
  }

  .left-icon {
    width: 68px;
    height: 68px;
    background: #ffa837;
    border-radius: 34px;
    margin-left: 10px;
  }
}
</style>
